import { cn } from 'src/lib/utils';
import type { EtlRollupStatus } from '../types/operations.types';
import {
  ROLLUP_STATUS_LABELS,
  ROLLUP_STATUS_PILL_COLOURS,
  rollupStatusFromRawStatus,
} from '../helpers/etl-health.helpers';

type Props = {
  status: string | EtlRollupStatus | null | undefined;
  className?: string;
};

export function EtlHealthStatusPill({ status, className }: Props) {
  const rollupStatus: EtlRollupStatus = typeof status === 'string'
    && ['green', 'yellow', 'red', 'no_data'].includes(status)
    ? status as EtlRollupStatus
    : rollupStatusFromRawStatus(status);

  const label = typeof status === 'string'
    && !['green', 'yellow', 'red', 'no_data'].includes(status)
    ? status
    : ROLLUP_STATUS_LABELS[rollupStatus];

  return (
    <span
      className={cn(
        'inline-flex w-fit items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold capitalize',
        ROLLUP_STATUS_PILL_COLOURS[rollupStatus],
        className,
      )}
    >
      {label}
    </span>
  );
}
